import { Select, Progress } from "antd";
import autoLoadIcon from "../../assets/autoLoading.png";
import React from "react";

interface LoadingProgress {
  currentPage: number;
  totalPages: number;
  percentage: number;
}

interface AutoLoadControlProps {
  /** 自定义加载图标 */
  loadIcon?: React.ReactNode;
  /** 是否正在加载 */
  autoLoading: boolean;
  /** 批量加载页数 */
  batchSize: number;
  /** 加载进度信息 */
  loadingProgress?: LoadingProgress;
  /** 是否禁用自动加载 */
  disabled: boolean;
  /** 批量页数变更回调 */
  onBatchSizeChange: (size: number) => void;
  /** 加载下一页回调 */
  onLoadNextPage: () => void;
  /** 开始自动加载回调 */
  onStartAutoLoad: () => void;
  /** 停止加载回调 */
  onStopLoad: () => void;
}

const BATCH_SIZE_OPTIONS = [
  { label: "5页", value: 5 },
  { label: "10页", value: 10 },
  { label: "15页", value: 15 },
  { label: "30页", value: 30 },
];

export const AutoLoadControl = ({
  autoLoading,
  batchSize,
  loadingProgress,
  loadIcon,
  onBatchSizeChange,
  onLoadNextPage,
  onStartAutoLoad,
  onStopLoad,
}: AutoLoadControlProps) => {
  if (autoLoading && loadingProgress) {
    return (
      <div className="auto_load_progress">
        {loadIcon ? (
          loadIcon
        ) : (
          <img src={autoLoadIcon} alt="自动加载" width={14} height={14} />
        )}
        <span>
          正在加载第{loadingProgress.currentPage}/{loadingProgress.totalPages}页
        </span>
        <Progress
          percent={loadingProgress.percentage}
          type="line"
          size={[160, 8]}
        />
        <span onClick={onStopLoad} className={"auto_load_stop_btn"}>
          停止加载
        </span>
      </div>
    );
  }

  return (
    <div className={"auto_load_container"}>
      <div
        onClick={onLoadNextPage}
        className="auto_load_next_btn"
        style={{
          backgroundColor: autoLoading ? "#f5f5f5" : "#2563eb",
        }}
      >
        加载下一页
      </div>

      {/* 自动加载组合按钮：左侧触发区 + 右侧下拉选择器 */}
      <div
        className={"right_control_wrap"}
        style={{
          backgroundColor: autoLoading ? "#f5f5f5" : "#2563eb",
        }}
      >
        <div
          className={"auto_load_btn"}
          onClick={autoLoading ? undefined : onStartAutoLoad}
        >
          {loadIcon ? (
            loadIcon
          ) : (
            <img src={autoLoadIcon} alt="自动加载" width={14} height={14} />
          )}
          <span>自动加载</span>
        </div>
        <Select
          value={batchSize}
          onChange={onBatchSizeChange}
          options={BATCH_SIZE_OPTIONS}
          disabled={autoLoading}
          size="small"
          className="auto_load_select"
          popupMatchSelectWidth={84}
        />
      </div>
    </div>
  );
};

export default AutoLoadControl;
